import { gql } from '@apollo/client';

export const UNVERIFY_CUSTOMER = gql`
  mutation UnverifyCustomer($input: UnverifyCustomer) {
    unverifyCustomer(input: $input) {
      customerUid
      externalVerificationType
      status
      message
    }
  }
`;
